import { render, staticRenderFns } from "./MedalManagement.vue?vue&type=template&id=2ac03a08&scoped=true"
import script from "./MedalManagement.vue?vue&type=script&lang=js"
export * from "./MedalManagement.vue?vue&type=script&lang=js"
import style0 from "./MedalManagement.vue?vue&type=style&index=0&id=2ac03a08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac03a08",
  null
  
)

export default component.exports